import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useLocaisOutletContext } from 'pages/Locais.context'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Local, local, updateLocalSchema } from 'service/api'
import { toast } from 'sonner'
import { LocalForm } from '../atoms/LocalForm'

export default function EditarLocal() {
    const { id } = useParams()
    const { data } = useLocaisOutletContext()
    const l = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = local.mutations.useUpdate({
        invalidateQuery: true,
    })

    if (!l) return null

    const handleSubmit: SubmitHandler<Local> = data =>
        mutateAsync(data, {
            onSuccess: () => {
                toast.success('Local atualizado com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            defaultValues={l}
            schema={updateLocalSchema}
            open={hasPermission(['update', 'Locais'])}
        >
            <Dialog.Title>Editar Local</Dialog.Title>
            <Dialog.Content>
                <FormField name="nomeLocal" label="Nome do Local" required />
                <LocalForm />
                <FormField name="latitude" hidden />
                <FormField name="longitude" hidden />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
